/**
 * FAQ content — original copy written for True Forge (a B2B safety-glove
 * manufacturer). Rendered by `src/pages/Faq.tsx` and emitted as FAQPage JSON-LD.
 */
export interface FaqItem {
  q: string
  a: string
}

export const faqIntro =
  'Common questions from distributors, importers and industrial buyers about True Forge products, standards, ordering and support. Need something not covered here? Get in touch and our team will help.'

export const faqs: FaqItem[] = [
  {
    q: 'What products does True Forge manufacture?',
    a: 'True Forge manufactures industrial safety gloves and leather garments — welding gloves (TIG/MIG and stick), driver gloves, and protective leather garments and accessories — engineered for welding, steel, oil & gas, construction and heavy industry.',
  },
  {
    q: 'Which safety standards do your welding gloves meet?',
    a: 'Our welding products are built to meet recognised EN standards: EN 388 (mechanical risks — abrasion, cut, tear, puncture), EN 407 (heat and flame), EN 12477 (welders’ gloves) and EN ISO 11611 (protective clothing for welding). Standards references indicate the levels our products are built to meet and are confirmed against each product’s documentation.',
  },
  {
    q: 'How do I choose the right welding glove — TIG, MIG or stick?',
    a: 'It depends on heat exposure and the dexterity the task needs. TIG welding favours thinner, high-dexterity gloves for fine control; MIG needs a balance of protection and feel; stick (SMAW) and heavy fabrication call for thicker, high-insulation gloves that prioritise heat resistance. Our range is organised around these tasks so you can match the glove to the process.',
  },
  {
    q: 'What leathers and linings do you use?',
    a: 'We select premium, purpose-matched materials: full-grain and split cowhide for durability and heat resistance, and goatskin where dexterity matters most. Welding models use heat-resistant linings and para-aramid (Kevlar-type) stitching engineered to withstand sparks and sustained heat.',
  },
  {
    q: 'Do you offer bulk and wholesale supply?',
    a: 'Yes. True Forge is a factory-direct manufacturer supplying distributors, importers and industrial buyers worldwide. We build around your order schedule with consistent quality and pricing — no middlemen.',
  },
  {
    q: 'Can you produce private-label or OEM gloves with our brand?',
    a: 'Yes. We offer private-label and OEM programmes — your brand and your specification, with custom branding, materials, sizing and construction on request.',
  },
  {
    q: 'Can I request samples before placing a bulk order?',
    a: 'Absolutely. We encourage buyers to evaluate quality first — request samples through our contact page and our team will arrange them.',
  },
  {
    q: 'What are your minimum order quantities and lead times?',
    a: 'MOQs and lead times depend on the product, customisation and volume. Share your requirement through the contact form and we’ll confirm quantities, timelines and pricing in your quotation.',
  },
  {
    q: 'Which markets do you export to?',
    a: 'We supply export-ready orders across welding, steel, oil & gas, construction and heavy-industry markets internationally. Tell us your destination and we’ll advise on supply.',
  },
  {
    q: 'How should welding gloves be cared for to last longer?',
    a: 'Keep gloves dry and store them away from direct heat and damp. Let them air-dry naturally after use rather than forcing heat, keep them clean of oil and grinding dust, and inspect seams, palms and cuffs regularly — retire any glove once protection is compromised.',
  },
  {
    q: 'How do I get a quote?',
    a: 'Send us your product, quantity and industry through the contact page. Our team responds promptly with a tailored quotation.',
  },
]
